// Styles des Editor-Inhalts. Der Inhalt liegt im Shadow DOM (index.vue): kein Travelize-CSS (Bulma, common.scss,
// modal.scss, tiptap.scss) kommt hinein, `all: initial` schneidet auch die Vererbung von der Seite ab. Hier steht
// nur, was die Mail beim Empfänger ausmacht (emailHtml.js schreibt dasselbe inline) – plus ProseMirror-Grundlagen.

import { DEFAULT_FONT_SIZE, FONT_FAMILY } from './houseStyle';

// aus @tiptap/core/src/style.ts (wird mit injectCSS nur in den <head> der Seite gehängt, nicht ins Shadow DOM)
const PROSEMIRROR = `
.ProseMirror { position: relative; word-wrap: break-word; white-space: pre-wrap; white-space: break-spaces;
    -webkit-font-variant-ligatures: none; font-variant-ligatures: none; font-feature-settings: "liga" 0; }
.ProseMirror [contenteditable="false"] { white-space: normal; }
.ProseMirror [contenteditable="false"] [contenteditable="true"] { white-space: pre-wrap; }
img.ProseMirror-separator { display: inline !important; border: none !important; margin: 0 !important; width: 0 !important; height: 0 !important; }
.ProseMirror-gapcursor { display: none; pointer-events: none; position: absolute; margin: 0; }
.ProseMirror-gapcursor:after { content: ""; display: block; position: absolute; top: -2px; width: 20px; border-top: 1px solid black;
    animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite; }
@keyframes ProseMirror-cursor-blink { to { visibility: hidden; } }
.ProseMirror-hideselection *::selection { background: transparent; }
.ProseMirror-hideselection * { caret-color: transparent; }
.ProseMirror-focused .ProseMirror-gapcursor { display: block; }
`;

const CONTENT = `
:host { all: initial; display: block; }
.email-editor-content { min-height: inherit; }

/* wie Outlook: Hausschrift (clientSpecific/email/editorStyle.js) 10pt, Absätze ohne Abstand, 12pt Zeilenabstand (wächst mit größerer Schrift mit) */
.ProseMirror {
    min-height: inherit; box-sizing: border-box; padding: 12px 16px; outline: none;
    font-family: ${FONT_FAMILY}; font-size: ${DEFAULT_FONT_SIZE};
    color: black; line-height: 1.2; text-align: left;
}
:host(.has-appendix) .ProseMirror { padding-bottom: 0; }
:host(.is-disabled) .ProseMirror { background: #f5f5f5; }

p { margin: 0; min-height: 1.2em; }
ul, ol { margin: 0; padding-left: 30px; }
ul { list-style: disc; }
ol { list-style: decimal; }
a { color: #0563c1; text-decoration: underline; }
img { max-width: 100%; }

/* Tabellen (HtmlBlock): unverändertes HTML im eigenen Shadow DOM, Text direkt bearbeitbar */
.email-html-block { outline: 1px solid transparent; outline-offset: 2px; }
.email-html-block:hover { outline-color: #d6e2f0; }
.email-html-block.ProseMirror-selectednode { outline: 2px solid #0563c1; }

/* Massenemail-Bausteine – Farben synchron mit .bulk-subject-input .bulk-twig-token (pages/emails/new_email.scss) */
.bulk-twig-token { background-color: #eef2f6; outline: 1px dashed #b9c6d2; border-radius: 3px; cursor: default; }
.bulk-twig-token.ProseMirror-selectednode { outline: 2px solid #0563c1; }
span.bulk-twig-token { padding: 0 2px; }

p.email-editor-empty:first-child::before {
    content: attr(data-placeholder); color: #adb5bd; float: left; height: 0; pointer-events: none;
}
`;

export default PROSEMIRROR + CONTENT;
